import React, { useMemo } from 'react';
import { FieldSet } from '@sencha/ext-modern'

import { getMixedProps } from '../blockPublic'

import FlowLog from './FlowLog'
import { useInstData } from 'tyan/public/hooks';

const FormFlowLog = props => {
	const { config: { defaultStyle,
		field: { label, ...field }
	} } = props

	const { me, me: { fieldID } } = useInstData(props, useMemo(() => ({ fieldID: `_flowLog-${Tyan.s4()}` }), []))
	const { props: {
		height, value,
		...pnlProps
	} } = getMixedProps('_flowLog', [defaultStyle, field])

	!label && (pnlProps.padding = '5px 0px 5px 0px')

	const compHeightProps = {}
	height && height !== '100%' && (compHeightProps.height = height)

	return <FieldSet id={`fieldset${fieldID}`} title={label} {...pnlProps} layout='fit' {...compHeightProps} errorTarget={undefined}>
		<FlowLog {...{ fieldID, height, value, field }} />
	</FieldSet>
}

const renderFlowLog = config => <FormFlowLog config={config} />

export default renderFlowLog